import { render, staticRenderFns } from "./all-visits.vue?vue&type=template&id=ee18874c"
import script from "./all-visits.vue?vue&type=script&lang=js"
export * from "./all-visits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports